import { selectCmsTjenesteTekster, selectCmsTjenesteTekstForHjelpetekstId } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
const TOGGLE_SHOW = 'hjelpeskuff/TOGGLE_SHOW';
const TOGGLE_SHOW_HELPITEM = 'hjelpeskuff/TOGGLE_SHOW_HELPITEM';
const SET_ACTIVE_HELPBUBBLE = 'hjelpeskuff/SET_ACTIVE_HELPBUBBLE';
const HIDE = 'hjelpeskuff/HIDE';
const SHOW = 'hjelpeskuff/SHOW';
const REMOVE_SEKSJON = 'hjelpeskuff/REMOVE_SEKSJON';
const TOGGLE_EXPANDED = 'hjelpeskuff/TOGGLE_EXPANDED';
const ADD_HJELPETRIGGER = 'hjelpeskuff/ADD_HJELPETRIGGER';
const REMOVE_HJELPETRIGGER = 'hjelpeskuff/ADD_HJELPETRIGGER';
const POPULATE_SKUFF = 'hjelpeskuff/POPULATE_SKUFF';
const initialState = {
    isOpen: false,
    activeBubble: undefined,
    activeSeksjonId: undefined,
    activeTriggerComponentId: undefined,
    seksjoner: [],
    defaultIsExpanded: undefined,
    triggerComponentIds: [],
};
function collapseAll(seksjoner) {
    return seksjoner.map((seksjon) => {
        if (seksjon.expanded) {
            return Object.assign({}, seksjon, {
                expanded: false,
            });
        }
        return seksjon;
    });
}
function isDefaultTrigger(action) {
    return action.hjelpetekstId === undefined;
}
export function processToggleShowHelp(state = initialState, action) {
    const { activeSeksjonId, activeTriggerComponentId } = state;
    let seksjoner = state.seksjoner;
    const sameTriggerId = activeSeksjonId === action.hjelpetekstId;
    const sameTriggerComponentId = activeTriggerComponentId ? activeTriggerComponentId === action.triggerComponentId : false;
    if (!isDefaultTrigger(action)) {
        if (seksjoner && !seksjoner.some(s => s.hjelpetekstId === action.hjelpetekstId)) {
            seksjoner = collapseAll(seksjoner).concat({
                hjelpetekstId: action.hjelpetekstId,
                tjenesteNavn: action.tjenesteNavn,
                expanded: true,
            });
        }
        else {
            seksjoner =
                state.seksjoner &&
                    state.seksjoner.map((seksjon) => {
                        if (seksjon.hjelpetekstId === action.hjelpetekstId && seksjon.tjenesteNavn === action.tjenesteNavn) {
                            return Object.assign({}, seksjon, { expanded: true });
                        }
                        if (seksjon.expanded) {
                            return Object.assign({}, seksjon, { expanded: false });
                        }
                        return seksjon;
                    });
        }
    }
    else if (seksjoner) {
        seksjoner = collapseAll(seksjoner);
    }
    if (!sameTriggerId || !state.isOpen) {
        // Add new helpsection to state
        return Object.assign({}, state, {
            isOpen: true,
            activeSeksjonId: action.hjelpetekstId,
            activeTriggerComponentId: action.triggerComponentId,
            tjenesteNavn: action.tjenesteNavn,
            activeBubble: undefined,
            seksjoner,
            defaultIsExpanded: isDefaultTrigger(action),
        });
    }
    else if (sameTriggerId && state.isOpen) {
        return Object.assign({}, state, {
            isOpen: false,
            activeSeksjonId: undefined,
            activeTriggerComponentId: undefined,
            activeBubble: undefined,
        });
    }
    else if (!sameTriggerComponentId) {
        // Add new active trigger id
        return Object.assign({}, state, {
            activeTriggerComponentId: action.triggerComponentId,
        });
    }
    // Same trigger clicked as last time, close drawer
    return Object.assign({}, state, {
        isOpen: false,
        activeSeksjonId: undefined,
        activeTriggerComponentId: undefined,
        activeBubble: undefined,
    });
}
function getBlankSeksjonIdIfActiv(action, state) {
    if (state.activeSeksjonId === action.hjelpetekstId) {
        return '';
    }
    return state.activeSeksjonId ? state.activeSeksjonId : '';
}
function removeSection(seksjoner, triggerId, tjenesteNavn) {
    if (triggerId != null && triggerId !== '' && seksjoner != null) {
        if (seksjoner.some(s => s.hjelpetekstId === triggerId)) {
            return seksjoner.filter(item => !(item.hjelpetekstId === triggerId && item.tjenesteNavn === tjenesteNavn));
        }
    }
    return seksjoner;
}
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_SHOW:
            return Object.assign({}, state, {
                isOpen: !state.isOpen,
                activeBubble: undefined,
                activeTriggerComponentId: undefined,
                defaultIsExpanded: state.defaultIsExpanded === undefined ? true : state.defaultIsExpanded,
            });
        case TOGGLE_SHOW_HELPITEM:
            return processToggleShowHelp(state, action);
        case SET_ACTIVE_HELPBUBBLE:
            return Object.assign({}, state, {
                isOpen: false,
                activeBubble: action.triggerComponentId,
                activeSeksjonId: undefined,
            });
        case HIDE:
            return Object.assign({}, state, {
                isOpen: false,
                activeTriggerComponentId: undefined,
            });
        case SHOW:
            return Object.assign({}, state, {
                isOpen: true,
                defaultIsExpanded: state.defaultIsExpanded === undefined ? true : state.defaultIsExpanded,
            });
        case REMOVE_SEKSJON:
            return Object.assign({}, state, {
                activeSeksjonId: getBlankSeksjonIdIfActiv(action, state),
                seksjoner: removeSection(state.seksjoner ? state.seksjoner : [], action.hjelpetekstId ? action.hjelpetekstId : '', action.tjenesteNavn ? action.tjenesteNavn : ''),
            });
        case TOGGLE_EXPANDED:
            if (isDefaultTrigger(action)) {
                return Object.assign({}, state, { defaultIsExpanded: !state.defaultIsExpanded });
            }
            return Object.assign({}, state, {
                seksjoner: state.seksjoner
                    ? state.seksjoner.map((seksjon) => {
                        if (seksjon.hjelpetekstId === action.hjelpetekstId && seksjon.tjenesteNavn === action.tjenesteNavn) {
                            return Object.assign({}, seksjon, {
                                expanded: !seksjon.expanded,
                            });
                        }
                        return seksjon;
                    })
                    : [],
            });
        case ADD_HJELPETRIGGER:
            return Object.assign({}, state, {
                triggerComponentIds: state.triggerComponentIds
                    ? [...state.triggerComponentIds, action.triggerComponentId]
                    : [action.triggerComponentId],
            });
        case REMOVE_HJELPETRIGGER:
            return Object.assign({}, state, {
                triggerComponentIds: state.triggerComponentIds ? state.triggerComponentIds.filter(id => id !== action.triggerComponentId) : [],
            });
        case POPULATE_SKUFF:
            return Object.assign({}, state, {
                seksjoner: state.seksjoner
                    ? state.seksjoner.concat({
                        hjelpetekstId: action.hjelpetekstId,
                        tjenesteNavn: action.tjenesteNavn,
                        expanded: true,
                    })
                    : [],
            });
        default:
            return state;
    }
}
export function toggleShowHjelpeskuff() {
    return {
        type: TOGGLE_SHOW,
    };
}
export function toggleShowHelpItem(triggerComponentId, hjelpetekstId, tjenesteNavn) {
    return {
        type: TOGGLE_SHOW_HELPITEM,
        triggerComponentId,
        hjelpetekstId,
        tjenesteNavn,
    };
}
export function removeSeksjonTekst(hjelpetekstId, tjenesteNavn) {
    return {
        type: REMOVE_SEKSJON,
        hjelpetekstId,
        tjenesteNavn,
    };
}
export function toggleExpanded(hjelpetekstId, tjenesteNavn) {
    return {
        type: TOGGLE_EXPANDED,
        hjelpetekstId,
        tjenesteNavn,
    };
}
export function hideHjelpeskuff() {
    return {
        type: HIDE,
    };
}
export function showHjelpeskuff() {
    return {
        type: SHOW,
    };
}
export function addHjelpetrigger(triggerComponentId) {
    return {
        type: ADD_HJELPETRIGGER,
        triggerComponentId: triggerComponentId,
    };
}
export function removeHjelpetrigger(triggerComponentId) {
    return {
        type: REMOVE_HJELPETRIGGER,
        triggerComponentId: triggerComponentId,
    };
}
export function setActiveBubble(triggerComponentId) {
    return {
        type: SET_ACTIVE_HELPBUBBLE,
        triggerComponentId: triggerComponentId,
    };
}
export function populateSkuff(hjelpetekstId, tjenesteNavn) {
    return {
        type: POPULATE_SKUFF,
        hjelpetekstId,
        tjenesteNavn,
    };
}
export function getTriggerData(state, hjelpetekstId, tjenesteNavn) {
    const triggerData = selectCmsTjenesteTekstForHjelpetekstId(state, tjenesteNavn, hjelpetekstId);
    if (triggerData != null) {
        const { sporsmaalTekst, hjelpeboble, hjelpetekst, overskrift } = triggerData;
        return {
            sporsmalstekst: sporsmaalTekst,
            bobletekst: hjelpeboble,
            hasSeksjonText: !!hjelpetekst?.length && !!overskrift,
        };
    }
    return undefined;
}
export function getActiveBubble(state) {
    const skuff = state.hjelpeskuff;
    return skuff.activeBubble ?? '';
}
export function getDefaultTekst(state, tjenesteNavn, hjelpetekstId) {
    const getDefaultTjenesteTekst = () => {
        const tjenesteTeksterDetails = selectCmsTjenesteTekster(state, tjenesteNavn);
        return {
            overskrift: tjenesteTeksterDetails?.data?.hjelpetekster?.overskift,
            brodtekst: tjenesteTeksterDetails?.data?.hjelpetekster?.hjelpetekst,
        };
    };
    const getSpesifikkHjelpetekst = () => {
        const spesifikkHjelpetekst = hjelpetekstId ? selectCmsTjenesteTekstForHjelpetekstId(state, tjenesteNavn, hjelpetekstId) : undefined;
        return {
            overskrift: spesifikkHjelpetekst?.overskrift,
            brodtekst: spesifikkHjelpetekst?.hjelpetekst,
        };
    };
    const shouldUseSpesifikkHjelpetekst = !!hjelpetekstId;
    const hjelpetekst = shouldUseSpesifikkHjelpetekst ? getSpesifikkHjelpetekst() : getDefaultTjenesteTekst();
    if (hjelpetekst.brodtekst && hjelpetekst.overskrift) {
        return {
            overskrift: hjelpetekst?.overskrift,
            brodtekst: hjelpetekst?.brodtekst,
            loading: false,
            error: false,
            expanded: state.hjelpeskuff.defaultIsExpanded,
        };
    }
    return null;
}
export function getSeksjonTekst(state, seksjon) {
    if (!seksjon.tjenesteNavn)
        return null;
    const hjelpeteksterForTjeneste = selectCmsTjenesteTekster(state, seksjon.tjenesteNavn);
    const hjelpetekst = hjelpeteksterForTjeneste?.data?.hjelpetekster?.spesifikkeHjelpetekster?.find(ht => ht.id === seksjon.hjelpetekstId);
    if (hjelpetekst) {
        return {
            overskrift: hjelpetekst.overskrift,
            brodtekst: hjelpetekst.hjelpetekst,
            hjelpetekstId: seksjon.hjelpetekstId,
            tjenesteNavn: seksjon.tjenesteNavn,
            loading: false,
            error: false,
            expanded: seksjon.expanded,
        };
    }
    return null;
}
